import Image from 'next/image';
import { useRouter } from 'next/router';

// Hooks
import useGiveawayPickerResults from '@/utils/hooks/giveaway-picker/useGiveawayPickerResults';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import Loader from '@/components/base/Loader';
// Components
import { LeftBlock } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/Results/LeftBlock';
import { RightBlock } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/Results/RightBlock';

import jellyco_purple from '../../../../../../public/images/giveaway-picker/Jellycos/jellyco_purple.png';

const ErrorDisplay = ({ message }) => (
    <div className="flex flex-col items-center justify-center">
        <Image src={jellyco_purple} alt="Jellyco Purple" width={60} height={60} className="mb-4" />
        {message}
    </div>
);

export const Results = () => {
    const { t } = useTranslation('giveaway_picker');
    const router = useRouter();

    const { id, signature } = router.query;
    const { giveawayResultsData, giveawayResultsError, isLoading } = useGiveawayPickerResults(
        id ? Number(id) : undefined,
        signature ? String(signature) : undefined
    );
    const result = giveawayResultsData;

    if (isLoading) return <Loader className="h-10 w-10 text-icoBlue" />;
    if (giveawayResultsError) return <ErrorDisplay message={t('results.error')} />;
    if (!giveawayResultsData) return <ErrorDisplay message={t('results.no_results')} />;

    return (
        <div className="flex min-h-screen flex-col-reverse md:flex-row">
            <LeftBlock result={result} />
            <RightBlock result={result} />
        </div>
    );
};
